import { render, staticRenderFns } from "./routerDetail.vue?vue&type=template&id=2f89387e&scoped=true"
import script from "./routerDetail.vue?vue&type=script&lang=js"
export * from "./routerDetail.vue?vue&type=script&lang=js"
import style0 from "./routerDetail.vue?vue&type=style&index=0&id=2f89387e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f89387e",
  null
  
)

export default component.exports